import { createFeature, createReducer, on, createSelector, createAction, props } from '@ngrx/store';
import { CommonApiState } from './common';
import { Task } from '../models/task';

export const TaskListFetch = createAction('[TaskList] Fetch', props<{ workspaceId: string }>());

export const TaskListFetched = createAction('[TaskList] Fetched', props<{ taskList: Task[] }>());

export const TaskListError = createAction('[TaskList] Error');

export const initialState: CommonApiState<{ tasks: Task[]; workspaceId: string }> = {
  data: { tasks: [], workspaceId: '' },
  currentPedingApis: 0,
  isError: false
};

export const taskListFeature = createFeature({
  name: 'taskList',
  reducer: createReducer(
    initialState,

    on(TaskListFetch, (state, result) => ({
      ...state,
      currentPedingApis: state.currentPedingApis + 1,
      isError: false,
      data: {
        workspaceId: result.workspaceId,
        tasks: state.data.tasks
      }
    })),

    on(TaskListFetched, (state, result) => {
      return {
        ...state,
        currentPedingApis: 0,
        isError: false,
        data: {
          tasks: result.taskList,
          workspaceId: state.data.workspaceId
        }
      };
    }),

    on(TaskListError, state => {
      return {
        ...state,
        currentPedingApis: 0,
        isError: true
      };
    })
  ),

  extraSelectors: ({ selectTaskListState }) => {
    const taskListIsLoading = createSelector(selectTaskListState, TaskListState => TaskListState.currentPedingApis > 0);

    const taskListHasPendingRequest = createSelector(
      selectTaskListState,
      TaskListState => TaskListState.currentPedingApis >= 2
    );
    const selectByWorkspaceId = (workspaceId: string) => {
      return createSelector(selectTaskListState, taskListState => {
        return taskListState.data.workspaceId === workspaceId ? taskListState.data.tasks : [];
      });
    };

    return {
      taskListIsLoading,
      taskListHasPendingRequest,
      selectByWorkspaceId
    };
  }
});
